/* eslint-disable no-nested-ternary */
import React from "react";
import moment from "moment";
import { FormattedMessage } from "react-intl";

import useFeatureFlag from "hooks/useFeatureFlag";
import { FEATURE_FLAGS } from "constants/featureFlags";
import CardItem from "./CardItem";

interface ILocationCardProps {
  label: React.ReactNode;
  country?: string;
  airportCode?: string;
  seaportCode?: string;
  city?: string;
  resolvedCountryLabel?: string;
  resolvedCountryValue?: string;
  isSameCountry: boolean;
  isReady: string;
  asapValue: string;
  readyTime?: string;
  readyDate?: string;
}

function LocationCard({
  label,
  country,
  airportCode,
  seaportCode,
  city,
  resolvedCountryLabel,
  resolvedCountryValue,
  isSameCountry,
  isReady,
  asapValue,
  readyTime,
  readyDate,
}: ILocationCardProps) {
  const isHeaderPortLabelingEnabled = useFeatureFlag(FEATURE_FLAGS.FF_WEB10382_HEADER_PORT_LABELING);
  const locationCode = airportCode || seaportCode;
  const locationLabel = isHeaderPortLabelingEnabled
    ? locationCode
      ? `${locationCode}`
      : isSameCountry
      ? `${city}, ${resolvedCountryValue}`
      : resolvedCountryLabel
    : isSameCountry
    ? `${city}, ${resolvedCountryValue}`
    : resolvedCountryLabel || locationCode;
  const hasLocation = isHeaderPortLabelingEnabled
    ? !!(locationCode || country || resolvedCountryLabel || city)
    : !!(country || resolvedCountryLabel || city || locationCode);

  return (
    <CardItem>
      <p className="font-b3 text-secondary">{label}</p>
      {hasLocation ? (
        <>
          <p className="font-b4">{locationLabel}</p>
          <p className="font-b3">
            {isReady === asapValue ? (
              <span>
                <FormattedMessage id="new-request.schedule.defaultCargoReadyOption.asap" defaultMessage="ASAP" />
              </span>
            ) : (
              <>
                {readyTime && (
                  <>
                    <span>{moment(readyDate).format("DD MMM")}, </span>
                    <span>{moment(readyTime, "HH:mm:ss").format("HH:mm")}</span>
                  </>
                )}
              </>
            )}
          </p>
        </>
      ) : (
        "-"
      )}
    </CardItem>
  );
}

export default LocationCard;
